import { useEmailPreview } from '@/state/useEmailPreview';

type EmailPreviewProps = {
  subject: string;
  greeting: string;
  content: string;
};

/**
 * The server-rendered email in a sandboxed frame. The frame keeps the dashboard's
 * own CSS out of the email and the email's out of the dashboard, so what shows
 * here is what a mail client receives.
 */
export const EmailPreview = ({ subject, greeting, content }: EmailPreviewProps) => {
  const { html, isFetching, isError } = useEmailPreview({ subject, greeting, content });

  if (isError) {
    return <p className="text-danger m-0 p-4 text-[12px]">The preview could not be rendered. Try again in a moment.</p>;
  }

  if (!html) {
    return (
      <p className="text-dim m-0 p-4 text-[12px]">{isFetching ? 'Rendering preview…' : 'Nothing to preview yet.'}</p>
    );
  }

  return <iframe title="Email preview" srcDoc={html} sandbox="" className="block h-[640px] w-full border-0 bg-white" />;
};
